import React, { useState } from 'react';
import { TextField, Button, Typography, Box, Alert } from '@mui/material';
import { tokens } from '../theme';
import { useAuth, homeFor } from '../context/AuthContext';
import { authAPI } from '../services/api';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const sessionExpired = params.has('expired');
  // Page à rouvrir après connexion (chemin interne uniquement)
  const suite = (params.get('suite') || '').startsWith('/') && !(params.get('suite') || '').startsWith('//') ? params.get('suite') : null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await authAPI.login(credentials);
      const { token, user } = response.data;
      login(token, user);
      if (user.must_change_password) {
        navigate('/change-password');
      } else {
        navigate(suite || homeFor(user.role));
      }
    } catch (error) {
      setError(error.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="main" sx={{ minHeight: '100vh', display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'minmax(360px, 42%) 1fr' }, bgcolor: '#fff' }}>
      {/* Panneau de marque : le trait vertical reprend celui du logo DOCC */}
      <Box sx={{ display: { xs: 'none', md: 'flex' }, position: 'relative', overflow: 'hidden', bgcolor: tokens.navy, color: '#fff', flexDirection: 'column', justifyContent: 'space-between', p: 6 }}>
        <Box aria-hidden sx={{ position: 'absolute', top: 0, bottom: 0, left: '50%', width: '2px', bgcolor: tokens.amber, opacity: 0.85 }} />
        <Box />
        <Box sx={{ position: 'relative', textAlign: 'center' }}>
          <Box component="img" src="/logo-mark-white.png" alt="" sx={{ display: 'block', height: 190, mx: 'auto', bgcolor: tokens.navy, px: 2 }} />
          <Typography sx={{ mt: 3, fontSize: 34, fontWeight: 700, letterSpacing: '0.18em', textIndent: '0.18em', bgcolor: tokens.navy, display: 'inline-block', px: 2, py: 0.5 }}>
            DOCC
          </Typography>
        </Box>
        <Box sx={{ position: 'relative', textAlign: 'center' }}>
          <Box sx={{ display: 'inline-block', bgcolor: tokens.navy, px: 2, py: 1 }}>
            <Typography sx={{ fontSize: 15, fontWeight: 500 }}>Production de poteaux béton armé</Typography>
            <Typography sx={{ fontSize: 14, opacity: 0.7 }}>Usine de Sangalkam</Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: { xs: 3, sm: 6 } }}>
        <Box sx={{ width: '100%', maxWidth: 380 }}>
          <Box component="img" src="/logo-docc.png" alt="DOCC" sx={{ display: { xs: 'block', md: 'none' }, height: 110, mx: 'auto', mb: 3 }} />
          <Typography variant="h4" component="h1">Connexion</Typography>
          <Typography color="text.secondary" sx={{ mt: 0.5, mb: 3 }}>
            Stock, livraisons et facturation de l'usine.
          </Typography>

          {sessionExpired && !error && (
            <Alert severity="info" sx={{ mb: 2 }}>Votre session a expiré, veuillez vous reconnecter.</Alert>
          )}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Nom d'utilisateur"
              autoComplete="username"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Mot de passe"
              type="password"
              autoComplete="current-password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
            />
            <Button type="submit" fullWidth variant="contained" size="large" sx={{ mt: 3, py: 1.25 }} disabled={loading}>
              {loading ? 'Connexion…' : 'Se connecter'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;